import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAnswerFormat implements BaseEnumType {
  private static allValues: EnumAnswerFormat[] = []; // make sure this is top-most
  
  public static none = new EnumAnswerFormat(0, "None", "enum_answer_format_none");
  public static text = new EnumAnswerFormat(1, "Text", "enum_answer_format_text");
  public static yesNo = new EnumAnswerFormat(2, "YesNo", "enum_answer_format_yes_no");
  public static number = new EnumAnswerFormat(3, "Number", "enum_answer_format_number");
  public static pickOne = new EnumAnswerFormat(4, "PickOne", "enum_answer_format_pick_one");
  public static pickAllThatApply = new EnumAnswerFormat(5, "PickAllThatApply", "enum_answer_format_pick_all_that_apply");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAnswerFormat.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumAnswerFormat.none; }
  public isText() { return this === EnumAnswerFormat.text; }
  public isYesNo() { return this === EnumAnswerFormat.yesNo; }
  public isNumber() { return this === EnumAnswerFormat.number; }
  public isPickOne() { return this === EnumAnswerFormat.pickOne; }
  public isPickAllThatApply() { return this === EnumAnswerFormat.pickAllThatApply; }

  public static getValues(): readonly EnumAnswerFormat[] {
    return EnumAnswerFormat.allValues;
  }

  public static getValuesExcept0(): readonly EnumAnswerFormat[] {
    return EnumAnswerFormat.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAnswerFormat {
    const found = EnumAnswerFormat.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAnswerFormat - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAnswerFormat): EnumAnswerFormat {
    const found = name ? EnumAnswerFormat.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAnswerFormat - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAnswerFormat>): boolean {
    return this.key === other?.key;
  }
}